<template>
    <div>
        <video ref="videoPlayer" class="video-js vjs-big-play-centered"></video>
        <video ref="videoPlayerBackup" class="backup-video-player" src="" style="display: none; width: 100%;" controls></video>
    </div>
</template>

<script>
import 'video.js/dist/video-js.css';
import videojs from 'video.js';

export default {
    name: "VideoPlayer",
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            player: null,
        }
    },
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.options, () => {
            this.player.on('error', (error) => {
                console.log('videojs error', error);
                this.destroyMainPlayer();
                this.setupBackupPlayer();
            })
        })
    },
    methods: {
        setupBackupPlayer() {
            console.log('Setting up backup video player...');
            if (this.$refs.videoPlayerBackup) {
                // Set the video source
                this.$refs.videoPlayerBackup.src = this.options.sources[0].src;
                this.$refs.videoPlayerBackup.style.display = 'block';
            } else {
                console.error('Could not set up backup video player. Element not found.');
            }
        },
        destroyMainPlayer() {
            console.log('destroying videojs player...');
            if (this.player) {
                this.player.dispose();
                this.player = null;
            }
        },
    },
    beforeUnmount() {
        this.destroyMainPlayer();

        if (this.$refs.videoPlayerBackup) {
            this.$refs.videoPlayerBackup.src = '';
            this.$refs.videoPlayerBackup.style.display = 'none';
        }
    }
}
</script>
